import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_2: FaireProductEntity = {
  token: "nyc-acc-2",
  type: "product",
  name: "Brooklyn Matchbox Set",
  brandName: "Brooklyn Match Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
  priceDollars: 8,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
  weight: 0.2,
  dimensions: {
    width: 2,
    height: 4,
    depth: 1,
  },
  description: "Artisanal matchbox set with Brooklyn design",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "artisanal"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
